import { useState, useEffect } from 'react';
import { buildValueFieldsForObject } from '../utils/filterFieldValueUtils';

/**
 * Loads base object fields plus parent lookup fields for filter/criteria "compare to field" dropdowns.
 */
export function useConditionValueFields(objectName) {
  const [valueFields, setValueFields] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!objectName) {
      setValueFields([]);
      return;
    }

    let cancelled = false;
    setLoading(true);

    (async () => {
      try {
        const { baseFields: bf, valueFields: vf } = await buildValueFieldsForObject(objectName);
        if (!cancelled) {
          setValueFields(vf?.length ? vf : bf);
        }
      } catch (e) {
        console.warn('[useConditionValueFields]', e);
        if (!cancelled) setValueFields([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [objectName]);

  return { valueFields, loadingValueFields: loading };
}
